module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_2@2x-7ae47db4ec08f7158b4515b094679b2b.jpg";